export default __webpack_public_path__ + "static/media/prevNew.dcc133ed.svg";